import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Contact Roles',
  basePath: '/contacts-roles',
  rowActions: [{ key: 'edit', label: 'Edit' }],
  columns: [
    { key: 'role', label: 'Role', sortable: true },
    { key: 'menu_client_names', label: 'Access', sortable: false },
  ],
  fields: [
    { key: 'role', label: 'Role', type: 'text', required: true },
    { key: 'menu_client', label: 'Access', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/menu-client/options' },
  ],
  defaultSort: { field: 'role', dir: 'asc' },
});
